export default __webpack_public_path__ + "static/media/Lulu 9781408339497.876b40b4.jpg";